<template>
  <div>
    <button
      :disabled="$store.state.isonlyread"
      v-show="datos.length > 0"
      class="btn btn-sm btn-link"
      @click="tableToExcel('table', 'Lorem Table')"
    >
      <span class="glyphicon glyphicon-print"></span> Descargar en formato EXCEL
    </button>

    <div v-if="datos.length">
      <v-text-field
        class="mt-2 ml-2 mr-2"
        style="width:350px;display:inline-block"
        label="Buscar"
        placeholder="texto a buscar..."
        hide-details
        outlined
        dense
        v-model="xfiltro"
        v-on:keyup.enter="findtext"
      ></v-text-field>

      <span class="py-0 blue--text">
        Los programas de color: <span style="background:#FFDFE1" class="px-3"></span>. son programas vencidos por
        recuperar.
      </span>

      <div v-if="tipoasignacion && tipoasignacion.id == 1" class="table-responsive mx-2" style="height: 76vh;">
        <table class="table-hover table-striped mx-1" id="midatatablexx" ref="table">
          <thead style="background:#196391;position: sticky; top: 0; z-index: 1;">
            <tr class="white--text">
              <th rowspan="2" class="toofixedx">Nro.</th>
              <th rowspan="2" style="min-width:280px" class="toofixed">PROGRAMAS</th>
              <th rowspan="2" style="min-width:150px">CODIGO DEL PROGRAMA</th>
              <th rowspan="2" style="min-width:180px;background:#6E621F" v-show="false">ENCARGADA DE LA COBRANZA</th>
              <th rowspan="2" style="min-width:80px;background:#6E621F">COSTO TOTAL</th>
              <th rowspan="2" style="min-width:100px;background:#6E621F">TOTAL N° DE ALUMNOS</th>
              <th colspan="5" style="background:#6E1F24">ASIGNACIÓN CUOTAS RETRASADAS</th>
              <th colspan="5" style="background:#1F6E43">ASIGNACIÓN VIGENTE</th>
              <th colspan="2">PAGOS ADELANTADOS</th>
            </tr>
            <tr class="white--text text-center">
              <!-- <th class="px-10" style="background:#6E1F24"></th> -->
              <th style="min-width:120px;background:#6E1F24">TOTAL ALUMNOS</th>
              <th style="background:#6E1F24">ASIGNACIÓN</th>
              <th class="px-8" style="background:#6E1F24">%</th>
              <th style="background:#6E1F24">COBRADO</th>
              <th style="background:#6E1F24">POR COBRAR</th>
              <!-- <th class="px-10" style="background:#6E1F24"></th> -->

              <th style="min-width:120px;background:#1F6E43">N° DE ALUMNOS P/C</th>
              <th style="background:#1F6E43">ASIGNACIÓN</th>
              <th class="px-8" style="background:#1F6E43">%</th>
              <th style="background:#1F6E43">COBRADO</th>
              <th style="background:#1F6E43">POR COBRAR</th>

              <th>ESTUDIANTES</th>
              <th>MONTO</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(d, ind) in datos" :key="ind" :style="d.style">
              <td class="toofixed2 black--text">{{ ind + 1 }}</td>
              <td
                class="toofixed2 manito"
                @click="irasignacionprograma(d)"
                title="Click para ir a asignacion del programa"
                :style="d.style ? d.style : ''"
              >
                {{ d.programa_nombre }}
              </td>
              <td>{{ d.programa_codigo }}</td>
              <td v-show="false"></td>
              <td>{{ parsecomas(d.cobranza.costo_total) }}</td>
              <td>{{ d.programa_inscritos }}</td>

              <!-- <td></td> -->
              <td>{{ d.cobranza.retraso_alumnos }}</td>
              <td>{{ parsecomas(d.cobranza.retraso_monto) }}</td>
              <td>{{ round(d.cobranza.retraso_importe, d.cobranza.retraso_monto) }} %</td>
              <td>{{ parsecomas(d.cobranza.retraso_importe) }}</td>
              <td>{{ parsecomas(d.cobranza.retraso_por_cobrar) }}</td>
              <!-- <td></td> -->

              <td>{{ d.cobranza.vigente_alumnos }}</td>
              <td>{{ parsecomas(d.cobranza.vigente_monto) }}</td>
              <td>{{ round(d.cobranza.vigente_importe, d.cobranza.vigente_monto) }} %</td>
              <td>{{ parsecomas(d.cobranza.vigente_importe) }}</td>
              <td>{{ parsecomas(d.cobranza.vigente_por_cobrar) }}</td>

              <td>{{ d.cobranza.adelanto_alumnos }}</td>
              <td>{{ parsecomas(d.cobranza.adelanto_monto) }}</td>
            </tr>
            <tr style="background:#1F6E43;color:white">
              <td class="toofixed2"></td>
              <td class="toofixed2 text-right">
                total: <br />
                total por recuperar:
              </td>
              <td></td>
              <td v-show="false"></td>
              <td>
                {{ parsecomas(totales.programa_costo_total) }} <br />
                {{ parsecomas(totales2.programa_costo_total) }}
              </td>
              <td>
                {{ totales.programa_inscritos }} <br />
                {{ totales2.programa_inscritos }}
              </td>

              <!-- <td></td> -->
              <td>
                {{ totales.retraso_alumnos }} <br />
                {{ totales2.retraso_alumnos }}
              </td>
              <td>
                {{ parsecomas(totales.retraso_monto) }} <br />
                {{ parsecomas(totales2.retraso_monto) }}
              </td>
              <td>
                {{ round(totales.retraso_importe, totales.retraso_monto) }} % <br />
                {{ round(totales2.retraso_importe, totales2.retraso_monto) }} %
              </td>
              <td>
                {{ parsecomas(totales.retraso_importe) }} <br />
                {{ parsecomas(totales2.retraso_importe) }}
              </td>
              <td>
                {{ parsecomas(totales.retraso_por_cobrar) }} <br />
                {{ parsecomas(totales2.retraso_por_cobrar) }}
              </td>
              <!-- <td></td> -->

              <td>
                {{ totales.vigente_alumnos }} <br />
                {{ totales2.vigente_alumnos }}
              </td>
              <td>
                {{ parsecomas(totales.vigente_monto) }} <br />
                {{ parsecomas(totales2.vigente_monto) }}
              </td>
              <td>
                {{ round(totales.vigente_importe, totales.vigente_monto) }} % <br />
                {{ round(totales2.vigente_importe, totales2.vigente_monto) }} %
              </td>
              <td>
                {{ parsecomas(totales.vigente_importe) }} <br />
                {{ parsecomas(totales2.vigente_importe) }}
              </td>
              <td>
                {{ parsecomas(totales.vigente_por_cobrar) }} <br />
                {{ parsecomas(totales2.vigente_por_cobrar) }}
              </td>

              <td>
                {{ totales.adelanto_alumnos }} <br />
                {{ totales2.adelanto_alumnos }}
              </td>
              <td>
                {{ parsecomas(totales.adelanto_monto) }} <br />
                {{ parsecomas(totales2.adelanto_monto) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div v-if="tipoasignacion && tipoasignacion.id == 2" class="table-responsive mx-2" style="height: 76vh;">
        <table class="table-hover table-striped mx-1" id="midatatablexx">
          <thead style="background:#196391;position: sticky; top: 0; z-index: 1;">
            <tr class="white--text">
              <th rowspan="2" class="toofixedx">Nro.</th>
              <th rowspan="2" style="min-width:280px" class="toofixed">PROGRAMAS</th>
              <th rowspan="2" style="min-width:150px">CODIGO DEL PROGRAMA</th>
              <th colspan="5" style="background:#6E1F24">INSCRIPCIONES CUOTAS RETRASADAS</th>
              <th colspan="4" style="background:#1F6E43">INSCRIPCIONES VIGENTE</th>
            </tr>
            <tr class="white--text text-center">
              <th class="px-10" style="background:#6E1F24"></th>
              <th style="background:#6E1F24">IMPORTE POR COBRAR</th>
              <th style="background:#6E1F24">IMPORTE COBRADO</th>
              <th style="background:#6E1F24">IMPORTE SALDO POR COBRAR</th>
              <th class="px-10" style="background:#6E1F24"></th>

              <th style="background:#1F6E43">IMPORTE POR COBRAR</th>
              <th style="background:#1F6E43">IMPORTE COBRADO</th>
              <th style="background:#1F6E43">IMPORTE SALDO POR COBRAR</th>
              <th class="px-10" style="background:#1F6E43"></th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="(d, ind) in datos" :key="ind" :style="d.style">
              <td class="toofixed2">{{ ind + 1 }}</td>
              <td class="toofixed2">{{ d.programa_nombre }}</td>
              <td>{{ d.programa_codigo }}</td>

              <td></td>
              <td>{{ parsecomas(d.ingreso_nuevo.retraso_monto) }}</td>
              <td>{{ parsecomas(d.ingreso_nuevo.retraso_importe) }}</td>
              <td>{{ parsecomas(d.ingreso_nuevo.retraso_por_cobrar) }}</td>
              <td></td>

              <td>{{ parsecomas(d.ingreso_nuevo.vigente_monto) }}</td>
              <td>{{ parsecomas(d.ingreso_nuevo.vigente_importe) }}</td>
              <td>{{ parsecomas(d.ingreso_nuevo.vigente_por_cobrar) }}</td>
              <td></td>
            </tr>
            <tr style="background:#1F6E43;color:white">
              <td class="toofixed2"></td>
              <td class="toofixed2"></td>
              <td></td>
              <td></td>
              <td>
                {{ parsecomas(totales.retraso_n_monto) }} <br />
                {{ parsecomas(totales2.retraso_n_monto) }}
              </td>
              <td>
                {{ parsecomas(totales.retraso_n_importe) }} <br />
                {{ parsecomas(totales2.retraso_n_importe) }}
              </td>
              <td>
                {{ parsecomas(totales.retraso_n_por_cobrar) }} <br />
                {{ parsecomas(totales2.retraso_n_por_cobrar) }}
              </td>
              <td></td>

              <td>
                {{ parsecomas(totales.vigente_n_monto) }} <br />
                {{ parsecomas(totales2.vigente_n_monto) }}
              </td>
              <td>
                {{ parsecomas(totales.vigente_n_importe) }} <br />
                {{ parsecomas(totales2.vigente_n_importe) }}
              </td>
              <td>
                {{ parsecomas(totales.vigente_n_por_cobrar) }} <br />
                {{ parsecomas(totales2.vigente_n_por_cobrar) }}
              </td>
              <td></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <p class="my-0 text-center">{{ msg }}</p>
    <notifications group="auth3" position="bottom right" />
  </div>
</template>

<style scoped>
  .manito:hover {
    cursor: pointer;
  }
  th {
    text-align: center;
  }
  td {
    text-align: right;
  }
  tr,
  td,
  th {
    border: 1px solid #555555;
    padding: 0;
    margin: 0;
    padding: 0 6px;
    z-index: 0;
  }
  table thead th {
    position: relative;
    font-size: 0.85em;
  }
  .toofixedx {
    background: #196391;
    position: sticky;
    left: 0;
    z-index: 10;
  }
  .toofixed {
    background: #196391;
    position: sticky;
    left: 30px;
    z-index: 100;
  }
  table tbody td:first-child {
    position: sticky;
    left: 0;
    background: #efefef;
    z-index: 0;
    text-align: left;
  }
  .toofixed2 {
    position: sticky;
    left: 30px;
    background: #efefef;
    z-index: 0;
    text-align: left;
  }
</style>

<script>
  import { myFunction1 } from '@/components/Utils';
  import xaxios from '@/xaxios';
  export default {
    data() {
      return {
        // EXCEL
        uri: 'data:application/vnd.ms-excel;base64,',
        template:
          '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head> <meta charset="utf-8"> <!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
        base64: function(s) {
          return window.btoa(unescape(encodeURIComponent(s)));
        },
        format: function(s, c) {
          return s.replace(/{(\w+)}/g, function(m, p) {
            return c[p];
          });
        },
        // END EXCEL
        datos: [],
        datos2: [],
        tipoasignacion: null,
        loading: false,
        xfiltro: '',
        msg: '',
        totales: [],
        totales2: [],
        xgestion: null,
        xmes: null,
      };
    },
    watch: {
      xfiltro: function() {
        this.findtext();
      },
      datos: {
        deep: true,
        handler: function() {
          window.sessionStorage.setItem('xdatosx', JSON.stringify(this.datos));
        },
      },
      datos2: {
        deep: true,
        handler: function() {
          window.sessionStorage.setItem('xdatos2x', JSON.stringify(this.datos2));
        },
      },
    },
    components: {},
    methods: {
      tableToExcel(table, name) {
        if (!table.nodeType) table = this.$refs.table;
        var ctx = { worksheet: name || 'Worksheet', table: table.innerHTML };
        var link = document.createElement('a');
        link.download = 'REPORTE_ASIGNACIONES_DE_PROGRAMAS_DE_LA_SEDE.xls';
        link.href = this.uri + this.base64(this.format(this.template, ctx));
        link.click();
      },
      findtext() {
        let table = document.getElementById('midatatablexx');
        myFunction1(this.xfiltro, table);
      },
      setipoasignacion(tipoasignacion) {
        this.tipoasignacion = tipoasignacion;
      },
      irasignacionprograma(p) {
        let obj = window.Object.assign({}, p);
        obj.xgestion = this.xgestion;
        obj.xmes = this.xmes;
        window.console.log(p);
        this.$router.push({ name: 'asignacionesv2', params: obj });
      },
      resetcache() {
        window.sessionStorage.setItem('xdatosx', JSON.stringify([]));
        window.sessionStorage.setItem('xdatos2x', JSON.stringify([]));
      },
      obtenerasignaciones(gestion, mes, tipoasignacion, convenio) {
        this.clearsumas();
        this.tipoasignacion = tipoasignacion;
        this.xgestion = gestion;
        this.xmes = mes;
        this.msg = '';
        const vue = this;
        vue.datos = [];
        vue.datos2 = [];
        if (!convenio) vue.cargarcache();
        let sede_id = this.$store.state.CARGO.sede.id;
        //let urla = `${process.env.VUE_APP_API_REST}/api/v1/sede/asignacion?`;
        let urla = `${process.env.VUE_APP_API_REST}/api/v1/asignacion/sede?`;
        urla += `year=${gestion}&month=${mes}&sede_id=${sede_id}`;
        if (convenio) urla += `&universidad_id=${convenio}`;
        const promise1 = xaxios.get(urla);
        window.console.log('>', urla);

        Promise.all([promise1])
          .then(function(values) {
            vue.datos = [];
            vue.datos2 = [];
            let data1 = values[0];
            vue.$emit('dataloaded');
            let dataa = data1.data.data;
            if (!dataa) dataa = [];
            vue.datos = dataa;
            vue.sumatoria(dataa);
            //window.console.log(">>", vue.datos);
          })
          .catch((e) => {
            vue.$emit('dataloaded');
            window.console.error(e);
            if (e.response.status == 403) {
              vue.msg = 'vuelva a ingresar al sistema para actualizar su session.';
            } else if (e.response.status == 500) {
              vue.msg =
                '(500) Actualmente estamos teniendo inconvientes al obtener los datos, lamentamos las molestias causadas :)';
            }
          });
      },
      clearsumas() {
        for (let i = 0; i < 2; i++) {
          let index = '';
          if (index == 1) index = '2';
          this['totales' + index].adelanto_alumnos = null;
          this['totales' + index].adelanto_monto = null;
          this['totales' + index].descuento_alumnos = null;
          this['totales' + index].descuento_monto = null;
          this['totales' + index].programa_costo_total = null;
          this['totales' + index].programa_grupo = null;
          this['totales' + index].programa_id = null;
          this['totales' + index].programa_inscritos = null;
          this['totales' + index].retraso_alumnos = null;
          this['totales' + index].retraso_descuento = null;
          this['totales' + index].retraso_importe = null;
          this['totales' + index].retraso_monto = null;
          this['totales' + index].retraso_n_descuento = null;
          this['totales' + index].retraso_n_importe = null;
          this['totales' + index].retraso_n_monto = null;
          this['totales' + index].retraso_n_por_cobrar = null;
          this['totales' + index].retraso_por_cobrar = null;
          this['totales' + index].vigente_alumnos = null;
          this['totales' + index].vigente_descuento = null;
          this['totales' + index].vigente_importe = null;
          this['totales' + index].vigente_monto = null;
          this['totales' + index].vigente_n_descuento = null;
          this['totales' + index].vigente_n_importe = null;
          this['totales' + index].vigente_n_monto = null;
          this['totales' + index].vigente_n_por_cobrar = null;
          this['totales' + index].vigente_por_cobrar = null;
        }
      },
      async sumatoria(datos) {
        window.console.log('>>', datos);
        const vue = this;
        datos.forEach((e) => {
          e.jerarquia = 0;
          e.style = vue.parsecolor(e);
          let index = '';
          if (e.jerarquia == 1) index = '2';

          if (!vue['totales' + index].adelanto_alumnos) vue['totales' + index].adelanto_alumnos = 0;
          vue['totales' + index].adelanto_alumnos += e.cobranza.adelanto_alumnos;
          if (!vue['totales' + index].adelanto_monto) vue['totales' + index].adelanto_monto = 0;
          vue['totales' + index].adelanto_monto += e.cobranza.adelanto_monto;
          if (!vue['totales' + index].descuento_alumnos) vue['totales' + index].descuento_alumnos = 0;
          vue['totales' + index].descuento_alumnos += e.descuento_alumnos;
          if (!vue['totales' + index].descuento_monto) vue['totales' + index].descuento_monto = 0;
          vue['totales' + index].descuento_monto += e.descuento_monto;
          if (!vue['totales' + index].programa_costo_total) vue['totales' + index].programa_costo_total = 0;
          vue['totales' + index].programa_costo_total += e.cobranza.costo_total;
          if (!vue['totales' + index].programa_grupo) vue['totales' + index].programa_grupo = 0;
          vue['totales' + index].programa_grupo += e.programa_grupo;
          if (!vue['totales' + index].programa_id) vue['totales' + index].programa_id = 0;
          vue['totales' + index].programa_id += e.programa_id;
          if (!vue['totales' + index].programa_inscritos) vue['totales' + index].programa_inscritos = 0;
          vue['totales' + index].programa_inscritos += e.programa_inscritos;
          if (!vue['totales' + index].retraso_alumnos) vue['totales' + index].retraso_alumnos = 0;
          vue['totales' + index].retraso_alumnos += e.cobranza.retraso_alumnos;
          if (!vue['totales' + index].retraso_descuento) vue['totales' + index].retraso_descuento = 0;
          vue['totales' + index].retraso_descuento += e.cobranza.retraso_descuento;
          if (!vue['totales' + index].retraso_importe) vue['totales' + index].retraso_importe = 0;
          vue['totales' + index].retraso_importe += e.cobranza.retraso_importe;
          if (!vue['totales' + index].retraso_monto) vue['totales' + index].retraso_monto = 0;
          vue['totales' + index].retraso_monto += e.cobranza.retraso_monto;
          if (!vue['totales' + index].retraso_n_descuento) vue['totales' + index].retraso_n_descuento = 0;
          vue['totales' + index].retraso_n_descuento += e.ingreso_nuevo.retraso_descuento;
          if (!vue['totales' + index].retraso_n_importe) vue['totales' + index].retraso_n_importe = 0;
          vue['totales' + index].retraso_n_importe += e.ingreso_nuevo.retraso_importe;
          if (!vue['totales' + index].retraso_n_monto) vue['totales' + index].retraso_n_monto = 0;
          vue['totales' + index].retraso_n_monto += e.ingreso_nuevo.retraso_monto;
          if (!vue['totales' + index].retraso_n_por_cobrar) vue['totales' + index].retraso_n_por_cobrar = 0;
          vue['totales' + index].retraso_n_por_cobrar += e.ingreso_nuevo.retraso_por_cobrar;
          if (!vue['totales' + index].retraso_por_cobrar) vue['totales' + index].retraso_por_cobrar = 0;
          vue['totales' + index].retraso_por_cobrar += e.cobranza.retraso_por_cobrar;
          if (!vue['totales' + index].vigente_alumnos) vue['totales' + index].vigente_alumnos = 0;
          vue['totales' + index].vigente_alumnos += e.cobranza.vigente_alumnos;
          if (!vue['totales' + index].vigente_descuento) vue['totales' + index].vigente_descuento = 0;
          vue['totales' + index].vigente_descuento += e.cobranza.vigente_descuento;
          if (!vue['totales' + index].vigente_importe) vue['totales' + index].vigente_importe = 0;
          vue['totales' + index].vigente_importe += e.cobranza.vigente_importe;
          if (!vue['totales' + index].vigente_monto) vue['totales' + index].vigente_monto = 0;
          vue['totales' + index].vigente_monto += e.cobranza.vigente_monto;
          if (!vue['totales' + index].vigente_n_descuento) vue['totales' + index].vigente_n_descuento = 0;
          vue['totales' + index].vigente_n_descuento += e.ingreso_nuevo.vigente_descuento;
          if (!vue['totales' + index].vigente_n_importe) vue['totales' + index].vigente_n_importe = 0;
          vue['totales' + index].vigente_n_importe += e.ingreso_nuevo.vigente_importe;
          if (!vue['totales' + index].vigente_n_monto) vue['totales' + index].vigente_n_monto = 0;
          vue['totales' + index].vigente_n_monto += e.ingreso_nuevo.vigente_monto;
          if (!vue['totales' + index].vigente_n_por_cobrar) vue['totales' + index].vigente_n_por_cobrar = 0;
          vue['totales' + index].vigente_n_por_cobrar += e.ingreso_nuevo.vigente_por_cobrar;
          if (!vue['totales' + index].vigente_por_cobrar) vue['totales' + index].vigente_por_cobrar = 0;
          vue['totales' + index].vigente_por_cobrar += e.cobranza.vigente_por_cobrar;
        });

        datos.sort((a, b) => {
          let f = 0;
          if (a.jerarquia < b.jerarquia) f = -1;
          else if (a.jerarquia > b.jerarquia) f = 1;
          return f;
        });

        window.console.log('>>', vue.totales);
      },
      round(a, b) {
        if (b == 0) b = 1;
        return ((a / b) * 100).toFixed(2);
      },

      parsecomas(str) {
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      cargarcache() {
        let datos = window.sessionStorage.getItem('xdatosx');
        let datos2 = window.sessionStorage.getItem('xdatos2x');
        // if (!datos) this.datos = [];
        // if (!datos2) this.datos2 = [];

        if (datos) this.datos = JSON.parse(datos);
        if (datos2) this.datos2 = JSON.parse(datos2);

        if (this.datos.length || this.datos2.length) {
          var noti = {
            group: 'auth3',
            type: 'success',
            title: 'Carga rapida',
            text:
              'Datos cargados rapidamente desde la ultima visualizacion, espere para cargar los datos mas recientes.',
            duration: 10000,
          };
          this.$notify(noti);
        }
        //window.console.log(datos,datos2);
      },
      parsecolor(d) {
        //recuperar la fecha de finalizacion
        //window.console.log('<>', d);
        if (!d.fecha_fin) return '';
        let date = new Date(d.fecha_fin);
        let ahora = new Date();
        ahora.setDate(1);
        ahora.setMonth(this.xmes - 1);
        ahora.setFullYear(this.xgestion);
        if (date.getTime() < ahora.getTime()) {
          d.jerarquia = 1;
          return 'background:#FFDFE1;color:black';
        }
        return '';
      },
    },
    mounted() {},
  };
</script>
